import client from "../index.js";
import { GET_YRH_COMMENTS } from "./query.js";
import {
  CREATE_YRH_COMMENT,
  UPDATE_YRH_COMMENT,
  DELETE_YRH_COMMENT,
} from "./mutation.js";

export const apiGetComments = (input) => {
  return client
    .query({
      query: GET_YRH_COMMENTS,
      variables: { input },
      fetchPolicy: "no-cache",
    })
    .then((res) => res?.data?.["yrhComments"]);
};

export const apiCreateComment = (input) => {
  return client
    .mutate({
      mutation: CREATE_YRH_COMMENT,
      variables: { input },
      fetchPolicy: "no-cache",
    })
    .then((res) => res?.data?.["createYrhComment"]);
};

export const apiUpdateComment = (input) => {
  return client
    .mutate({
      mutation: UPDATE_YRH_COMMENT,
      variables: { input },
      fetchPolicy: "no-cache",
    })
    .then((res) => res?.data?.["updateYrhComment"]);
};

export const apiDeleteComment = (id) => {
  return client
    .mutate({
      mutation: DELETE_YRH_COMMENT,
      variables: { id },
      fetchPolicy: "no-cache",
    })
    .then((res) => res?.data?.["deleteYrhComment"]);
};
